<script lang="ts" setup>
import homeIcon from "assets/icons/menuHeader/home.svg?component";
import catalogIcon from "assets/icons/menuHeader/catalog.svg?component";
import profileIcon from "assets/icons/menuHeader/profile.svg?component";
import balanceIcon from "assets/icons/menuHeader/balance.svg?component";
import cartIcon from "assets/icons/menuHeader/cart.svg?component";
import NavigationMenu from '~/entities/navigation/NavigationMenu.vue';
import useCartStore from "~/shared/store/modules/cart";
import useAccountStore from "~/shared/store/modules/account";
import useMainStore from "~/shared/store";
import {useWindowScroll} from '~/composables/scroll-event';
import type {IScrollInfo} from "~/shared/interfaces/composables";
import type {INavigationItemHeader} from "~/shared/interfaces/ui/navigation";

const isGuest = computed(() => useAccountStore().userRole === 'guest')
const cartStore = useCartStore()
const mainStore = useMainStore()

const getStickyMenu = computed((): INavigationItemHeader[] => {
  const cartIndicatorSettings: INavigationItemHeader['indicator'] = {
    active: Boolean(cartStore.cartPreview.length),
    text: cartStore.cartPreview.length,
    color: 'orange',
  }
  if (isGuest.value) {
    return [
      {
        name: 'Главная',
        href: '/',
        icon: homeIcon,
      },
      {
        name: 'Каталог',
        href: '/catalog',
        icon: catalogIcon,
      },
      {
        name: 'Корзина',
        href: '/cart',
        icon: cartIcon,
        indicator: cartIndicatorSettings,
      },
      {
        name: 'Войти',
        href: 'javascript:',
        icon: profileIcon,
        clickFunc: () => mainStore.setAuthModalState(true)
      }
    ]
  } else {
    return [
      {
        name: 'Главная',
        href: '/',
        icon: homeIcon,
      },
      {
        name: 'Каталог',
        href: '/catalog',
        icon: catalogIcon,
      },
      {
        name: 'Корзина',
        href: '/cart',
        icon: cartIcon,
        indicator: cartIndicatorSettings,
      },
      {
        name: 'Баланс',
        href: '/account/finance',
        icon: balanceIcon,
      },
      {
        name: 'Профиль',
        href: '/account',
        icon: profileIcon,
      }
    ]
  }
})

let scrollInfo: IScrollInfo | null = null;

if (process.client) {
  scrollInfo = useWindowScroll();
}

</script>

<template>
  <NavigationMenu
    class="sticky-menu"
    :class="scrollInfo?.isScrollDown && 'sticky-menu__scroll'"
    :navigationMenu="getStickyMenu"
  />
</template>

<style lang="scss" scoped>
//@import '@/assets/styles/_mixins/_breakpoints.scss';

.sticky-menu {
  display: none !important;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: $bg_page;
  border-top: 1px solid $bg_border;
  padding: 12px 0 27px;
  transform: translateY(14px);
  transition: transform .3s;
  z-index: 10;

  &__scroll {
    transform: translateY(0px);
  }

  @include md-breakpoint {
    display: flex !important;
  }
}
</style>
